import supportedCountries from '../data/supportedCountries.json.js';

// Importing from `.json.js` a workaround for a bug in web browsers' "native"
// import patterns from '../data/patterns.json';

/** ---------------------------------------------------------------------------------------
 * getSupportedCountries
 *  
 * @return {Array<string>} Array of supported country codes
 * 
 */
const getSupportedCountries = () => {
  return supportedCountries;
};

export { getSupportedCountries };
